'use client'

import { BreadcrumbComponent } from '@/components/atoms/breadcrumbComponent'
import FooterFactory from '@/components/organisms/footer/FooterFactory'
import NavigationFactory from '@/components/organisms/navigation/navigationFactory'
import { Cultures, PageTypes } from '@/types/enums'
import {
  FilterGroup,
  FilterOption,
  FilterOptionsContext,
} from '@/utils/filterOptionsContext'
import { I18nProvider } from '@/utils/providers/I18nProvider'
import { Box, chakra } from '@chakra-ui/react'
import { AnimatePresence } from 'framer-motion'
import { ReactNode } from 'react'

export interface PageWrapperProps {
  children: ReactNode
  pageType: PageTypes
  navigationData: any
  footerData: any
  filterOptions: {
    [key in Cultures]: {
      filters: Record<string, FilterOption[]>
    }
  },
  culture: Cultures
  umbracoMessages: Record<string, string>
  pageHierarchyInfo: PageHierarchyInfo
}

export function PageWrapper({
  navigationData,
  footerData,
  filterOptions,
  pageType,
  pageHierarchyInfo,
  culture,
  umbracoMessages,
  children,
  ...props
}: PageWrapperProps) {
  const mappedFilters = Object.entries(filterOptions?.[culture].filters).map(
    ([key, value]): FilterGroup => {
      return {
        groupName: key,
        filters: value as FilterOption[],
      }
    },
  )

  return (
    <I18nProvider culture={culture} umbracoMessages={umbracoMessages}>
      <FilterOptionsContext.Provider value={{ filterOptions: mappedFilters }}>
        <NavigationFactory
          navigationData={navigationData}
          pageHierarchyInfo={pageHierarchyInfo}
        />
        <AnimatePresence mode='wait'>
          <chakra.main py={{ base: 6, md: 9 }} {...props}>
            {pageType !== PageTypes.SearchPage &&
              pageHierarchyInfo.breadCrumbTrail.length > 1 && (
                <Box px={{ base: 4, md: 9 }}>
                  <BreadcrumbComponent
                    items={pageHierarchyInfo.breadCrumbTrail}
                  />
                </Box>
              )}
            {children}
          </chakra.main>
        </AnimatePresence>
        <FooterFactory data={footerData} />
      </FilterOptionsContext.Provider>
    </I18nProvider>
  )
}
